import { render, staticRenderFns } from "./accountInfo1.vue?vue&type=template&id=5cd025f2&scoped=true"
import script from "./accountInfo1.vue?vue&type=script&lang=js"
export * from "./accountInfo1.vue?vue&type=script&lang=js"
import style0 from "./accountInfo1.vue?vue&type=style&index=0&id=5cd025f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd025f2",
  null
  
)

export default component.exports